import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message, Popconfirm, Modal } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import TableC from '../../basicElement/TableC';
import { SetRecord, RegisterLPI, RegisterStartUp, ExportModal } from './components/PreviewModal';
import { saveCurrentPerformance, saveEnrollParams } from '../../../actions/competeCompanyActions';
import { saveParams } from '../../../actions/noticeActions';
import Update from './components/Update';
import Detail from './components/Detail';
import Filter from './components/Filter';
import format from '../../shared/format';
import SideNav from '../SideNav';
import StartTotalModal from './components/StartTotalModal';

const makeRender = (params = {}) => {
    return (text, record) => {
        const obj = {
            children: text,
            props: {},
        };
        const { strongText, computeColSpan } = params;
        if (strongText) {
            obj.children = strongText(text, record);
        }
        if (computeColSpan) {
            obj.props.colSpan = computeColSpan(text, record);
        }
        return obj;
    };
};
const strongText = (text, record) => record['num'] === '合计' ? <strong>{text}</strong> : text;
const computeColSpan = (colSpan) => (text, record) => record['num'] === '合计' ? colSpan : 1;

class Performance extends Component {
    constructor(props) {
        super(props);
        const { competingCompanyId, competingCompanyName, hospitalId, hospitalName, departmentId, departmentName } = props;
        this.state = {
            searchParams: {
                competingCompanyId,
                competingCompanyName,
                hospitalId,
                hospitalName,
                departmentId,
                departmentName
            },
            loading: false
        };
    }

    componentDidMount() {
        const { current } = this.props;
        this.setState({
            pagination: {
                current,
                limit: 3,
            },
        }, () => {
            this.loadData();
        });
        this.queryInvestigationStageByInvId();
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.props.saveParams({ 
            competingCompanyId: undefined,
            competingCompanyName: undefined, 
            hospitalId: undefined, 
            hospitalName: undefined, 
            departmentId: undefined, 
            departmentName: undefined, 
        });
    }

    loadData = () => {
        const { invId } = sessionStorage;
        const { pagination, pagination: { current, limit }, searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryCompeteCompanyList,
            data: {
                limit,
                offset: current,
                ...searchParams,
                investigationId: invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount = 0, datas = [], investigation } = res;
                const { groupRecordMode } = investigation || {};
                pagination.pageSize = datas.length;
                pagination.total = Math.ceil(totalCount / 3) * datas.length;
                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                    groupRecordMode,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleDelete = (competingCompanyManifestationId) => {
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.deleteCompeteCompany,
            data: {
                competingCompanyManifestationId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const { pagination } = this.state;
                pagination.current = 1;
                this.setState({
                    pagination
                }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({
            searchParams: {...params},
            pagination
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        this.exportRef.show({...searchParams});
    }

    showStartTotalModal = () => {
        this.startTotalModalRef.show();
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'num',
            key: 'num',
            width: 60,
            fixed: 'left',
            render: makeRender({
                strongText,
                computeColSpan: computeColSpan(11)
            })
        }, {
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            width: 120,
            fixed: 'left',
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '实际启动总site数',
            dataIndex: 'actualStartSiteAmount',
            key: 'actualStartSiteAmount',
            width: 110,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '实际入组总数',
            dataIndex: 'actualRandomAmount',
            key: 'actualRandomAmount',
            width: 110,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }]
        columns.push({
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 160,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 120,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        },{
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 80,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: 'PI',
            dataIndex: 'piUserName',
            key: 'piUserName',
            width: 80,
            render: makeRender({
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '中心是否已启动',
            dataIndex: 'siteIsStart',
            key: 'siteIsStart',
            width: 120,
            render: makeRender({
                strongText: (text, record) => text ? text == 1 ? '是' : '否' : '',
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '递交立项资料时间',
            dataIndex: 'projectApprovalTime',
            key: 'projectApprovalTime',
            width: 120,
            render: makeRender({
                strongText: (text, record) => format('date', text),
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '启动时间',
            dataIndex: 'beginTime',
            key: 'beginTime',
            width: 100,
            render: makeRender({
                strongText: (text, record) => format('date', text),
                computeColSpan: computeColSpan(0)
            })
        }, {
            title: '启动时长(天)',
            dataIndex: 'beginDay',
            key: 'beginDay',
            width: 100,
            render: makeRender({
                computeColSpan: computeColSpan(0) //合计行所占的列数
            })
        }, {
            title: 'open天数',
            dataIndex: 'openDay',
            key: 'openDay',
            width: 80,
            render: makeRender({ strongText, computeColSpan: computeColSpan(0) })
        }, {
            title: '累计筛选数量',
            dataIndex: 'filterOutNumber',
            key: 'filterOutNumber',
            width: 100,
            render: makeRender({ strongText, computeColSpan: computeColSpan(0) })
        }, {
            title: '累计入组数量',
            dataIndex: 'groupNumber',
            key: 'groupNumber',
            width: 100,
            render: makeRender({ strongText })
        }, {
            title: '入组周速率',
            dataIndex: 'weekGroupSpeed',
            key: 'weekGroupSpeed',
            width: 100,
            render: makeRender({ strongText })
        }, {
            title: '入组月速率',
            dataIndex: 'monthGroupSpeed',
            key: 'monthGroupSpeed',
            width: 100,
            render: makeRender({ strongText })
        }, {
            title: 'LPI',
            dataIndex: 'lpiTime',
            key: 'lpiTime',
            width: 100,
            render: makeRender({
                strongText: (text, record) => {
                    return strongText(format('date', text), record);
                }
            })
        }, {
            title: '更新日期',
            dataIndex: 'updateTime',
            key: 'updateTime',
            width: 100,
            render: makeRender({
                strongText: (text, record) => {
                    return strongText(<a onClick={() => this.showDetail(record)}>{format('date', text)}</a>, record);
                }
            })
        });
        const { curRole } = sessionStorage;
        if (curRole == 'PA' || curRole == 'PM') {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 180,
                render: (text, record) => {
                    const  { num, competingCompanyManifestationId } = record;
                    if (num != '合计') {
                        const obj = { props: {} };
                        obj.children = (
                            <span>
                                <a onClick={() => this.canEditByInvStatus(() => this.update(record))}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title='确认要删除该竞争公司中心记录?' onConfirm={() => this.canEditByInvStatus(() => this.handleDelete(competingCompanyManifestationId))} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                                <a onClick={() => this.canEditByInvStatus(() => this.registerStartUp(record))}>登记启动情况</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.canEditByInvStatus(() => this.checkRegisterEnroll(record, this.registerEnroll)) }>登记入组情况</a>
                                {/* <span className="ant-divider" />  // 需求变更，暂时隐藏
                                <a onClick={() => this.canEditByInvStatus(() => this.registerLPI(record))}>登记LPI</a> */}
                            </span>
                        );
                        return obj;
                    }
                }
            });
        } else {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 105,
                render: (text, record) => {
                    if (record.num != '合计') {
                        const obj = { props: {} };
                        obj.children = (
                            <a onClick={() => this.registerEnroll(record)}>查看入组情况</a>
                        );
                        return obj;
                    }
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;

        let key = 0, idx = 1;
        const dataSource = [];
        if (data && data.length > 0) {
            data.map(item => {
                if (item.companyName == '合计') {
                    dataSource.push({
                        key: key++,
                        num: '合计',
                        ...item,
                    });
                    idx = 1;
                } else {
                    dataSource.push({
                        key: key++,
                        num: idx++,
                        ...item,
                    });
                }
            });
        }
        return dataSource;
    }
    
    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    setRecord = () => {
        const { groupRecordMode } = this.state;
        this.setRecordRef.show(groupRecordMode);
    }

    registerStartUp = (record) => {
        this.registerStartUpRef.show(record);
    }

    checkRegisterEnroll = (record, callback) => {
        const { siteIsStart } = record;
        if ( siteIsStart != 1) {
            Modal.confirm({
                title: '竞争公司中心尚未启动，无法登记入组情况！',
                okText: '登记启动情况',
                cancelText: '放弃登记入组情况',
                onOk: () => this.registerStartUp(record)
            });
        } else {
            callback(record);
        }
    }

    registerEnroll = (record) => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.checkCompetingCompanyGroup,
            data: { investigationId: invId },
            dataType: 'json',
            doneResult: res => {
                if (!res.success) {
                    message.warning('请先设置本项目的入组情况记录方式');
                } else {
                    const { saveEnrollParams, saveCurrent } = this.props;
                    const { pagination: { current } } = this.state;
                    saveCurrent(current)
                    saveEnrollParams({
                        ...record,
                        type: res.success,
                    });
                    this.timer = setTimeout(() => {
                        location.href = './#/competeCompany/enrollment'; 
                    }, 300);
                }
            },
        };
        $.sendRequest(options);
    }

    registerLPI = (record) => {
        this.registerLPIRef.show(record);
    }

    update = (record) => {
        const { actualStartSiteAmount, actualRandomAmount } = record || {};
        // 判断是否存在实际启动总site数和实际入组总数
        if (!!actualStartSiteAmount && !!actualRandomAmount) {
            // 如果存在，则弹出修改竞争公司启动入组总数弹窗
            this.startTotalModalRef.show(record);
        } else {
            // 如果不存在，则弹出原本的弹窗
            this.updateRef.show(record);
        }
    }

    showDetail = (record) => {
        this.detailRef.show(record);
    }

    render() {
        const { loading, pagination, searchParams } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='performance' />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        update={this.update}
                        setRecord={this.setRecord}
                        showStartTotalModal={this.showStartTotalModal}
                        searchParams={searchParams}
                        canEditByInvStatus={this.canEditByInvStatus}
                    />
                    <div style={{ color: 'red' }}>优先进行竞争公司中心具体启动、入组数据录入，若不明确具体中心情况时，可进行竞争公司启动入组总数数据录入</div>
                    <TableC
                        loading={loading}
                        rowKey="key"
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                    <SetRecord ref={el => this.setRecordRef = el} loadData={this.loadData} />
                    <RegisterStartUp ref={el => this.registerStartUpRef = el} loadData={this.loadData} />
                    <RegisterLPI ref={el => this.registerLPIRef = el} loadData={this.loadData} />
                    <Update ref={el => this.updateRef = el} loadData={this.loadData} />
                    <Detail ref={el => this.detailRef = el} />
                    <ExportModal ref={el => this.exportRef = el} />
                    <StartTotalModal ref={el => this.startTotalModalRef = el} loadData={this.loadData} />
                </div>           
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    current: state.competeCompanyState.current,
    ...state.noticeState.params,
})

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveParams(params)),
    saveEnrollParams: (params) => dispatch(saveEnrollParams(params)),
    saveCurrent: (current) => dispatch(saveCurrentPerformance(current)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Performance);


// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/index.js